import { Box, Button, IconButton, Typography } from "@mui/material";
import Table from "components/Table";
import { useState } from "react";
import CreateTask from "./tasks/createTask";
import FloatingButton from "components/FloatingButton";
import { Link } from "react-router-dom";
import moment from "moment";
import { deleteRequestTask, getRequestTasks } from "api/services/tasks";
import { ResType } from "types";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { snack } from "components/toast";
import { Delete, Edit, Visibility } from "@mui/icons-material";
import ViewDescription from "./documents/ViewDescription";
import EditTask from "./tasks/editTask";
import { useConfirm } from "context/ConfirmDialog";
import { deleteRequestDocument, getRequestDocuments } from "api/services/storage";
import CreateDocument from "./documents/createDocument";
import EditDocument from "./documents/editDocument";

function RequestDocuments() {
    const [open, setOpen] = useState<boolean>(false);
    const [page, setPage] = useState<number>(0);
    const [pageCount, setPageCount] = useState<number>(10);
    const [documentsData, setDocumentsData] = useState<any>([]);
    const [infoOpen, setInfoOpen] = useState(false);
    const [selectedDescription, setSelectedDescription] = useState("");
    const [totalCount, setTotalCount] = useState<number>(0);


    const { data, isLoading }: ResType = useQuery(
        ["requested-documents", { limit: pageCount, offset: page * pageCount, clientId: localStorage.getItem("clientId") || "" }],
        getRequestDocuments, {
        onSuccess: (data: any) => {
            setDocumentsData(data?.data?.[0] || []);
            setTotalCount(data?.data?.[1] || 0);
        },
        onError: (err: any) => {
            if (!err?.error) {
                snack.error(`An error occurred while fetching tasks`);
            }
        }
    }
    );
    const columns = [
        { key: "documentName", title: "Document Name", render: (row: any) => row?.documentName || "-", width: "25%" },
        {
            key: "description", title: "Description", render: (row: any) => <Button
                onClick={() => {
                    setSelectedDescription(row.description || "No Description Available");
                    setInfoOpen(true);
                }}
            >
                <Visibility />
            </Button>
        },
        {
            key: "uploadDocs", title: "Upload Docs", render: (row: any) => <Box>
                <Button color="secondary" variant="contained" sx={{ fontSize: "12px" }}>+ Attachments</Button>
            </Box>
        },
        {
            key: "createdAt", title: "Requested At", render: (row: any) => moment(row?.createdAt).format("DD/MM/YYYY HH:mm:ss")
        },
        { key: "actions", title: "Actions", render: (row: any) => row?.task?.taskNumber ? <Typography color="green">Task Created</Typography> : <Actions row={row} /> }
    ];

    return <Box>
        <Table
            sx={{ pb: 0, mb: 0, height: "475px" }}
            pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
            data={documentsData || []}
            columns={columns}
        />
        <CreateDocument open={open} setOpen={setOpen} />
        <FloatingButton onClick={() => setOpen(true)} />
        <ViewDescription open={infoOpen} setOpen={setInfoOpen} description={selectedDescription} />
    </Box>;
}

const Actions = ({ row }: any) => {
    const [editData, setEditData] = useState<any>(null);
    const [openEdit, setOpenEdit] = useState(false);
    const confirm = useConfirm();
    const queryClient = useQueryClient();

    const { mutate, isLoading } = useMutation(deleteRequestDocument, {
        onSuccess: () => {
            snack.success("Document Request Deleted Successfully");
            queryClient.invalidateQueries("requested-documents");
        },
        onError: (err: any) => {
            snack.error(err.response.data.message);
        },
    });


    const handleDeleteClick = () => {
        confirm({
            msg: `Are you sure you want to delete this document request ?`,
            action: () => {
                mutate({ id: row.id });
            },
        });
    }

    return <Box>
        <IconButton component={"button"} onClick={() => {
            setEditData(row);
            setOpenEdit(true);
        }}>
            <Edit />
        </IconButton>
        <IconButton component={"button"} onClick={() => {
            handleDeleteClick()
        }}>
            <Delete />
        </IconButton>
        <EditDocument open={openEdit} setOpen={setOpenEdit} editData={editData} />
    </Box>
}

export default RequestDocuments;
